import { toast } from 'sonner';

interface AlertOptions {
  variant: 'success' | 'error' | 'info' | 'warning';
  message: string;
  options?: object;
}

/**
 * @name Alert
 * @param {"success" | "error" | "info" | "warning"} variant
 * @param {string} message
 * @param {Object} options
 */
const Alert = ({ variant, message, options }: AlertOptions) =>
  toast[variant](message, { ...options });

export default Alert;
